'use strict';

var _construct = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
var _defineProperty = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
function withIs(Class, _ref) {
  var className = _ref.className,
    symbolName = _ref.symbolName;
  var symbol = Symbol.for(symbolName);
  var ClassIsWrapper = _defineProperty({}, className, /*#__PURE__*/function (_Class) {
    _inherits(_class, _Class);
    function _class() {
      var _getPrototypeOf2;
      var _this2;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));
      Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), symbol, {
        value: true
      });
      return _this2;
    }
    _createClass(_class, [{
      key: Symbol.toStringTag,
      get: function get() {
        return className;
      }
    }]);
    return _class;
  }(Class))[className];
  ClassIsWrapper["is".concat(className)] = function (obj) {
    return !!(obj && obj[symbol]);
  };
  return ClassIsWrapper;
}
function withIsProto(Class, _ref2) {
  var className = _ref2.className,
    symbolName = _ref2.symbolName,
    withoutNew = _ref2.withoutNew;
  var symbol = Symbol.for(symbolName);

  /* eslint-disable object-shorthand */
  var ClassIsWrapper = _defineProperty({}, className, function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (withoutNew && !(this instanceof ClassIsWrapper)) {
      return _construct(ClassIsWrapper, args);
    }
    var _this = Class.call.apply(Class, [this].concat(args)) || this;
    if (_this && !_this[symbol]) {
      Object.defineProperty(_this, symbol, {
        value: true
      });
    }
    return _this;
  })[className];
  /* eslint-enable object-shorthand */

  ClassIsWrapper.prototype = Object.create(Class.prototype);
  ClassIsWrapper.prototype.constructor = ClassIsWrapper;
  Object.defineProperty(ClassIsWrapper.prototype, Symbol.toStringTag, {
    get: function get() {
      return className;
    }
  });
  ClassIsWrapper["is".concat(className)] = function (obj) {
    return !!(obj && obj[symbol]);
  };
  return ClassIsWrapper;
}
module.exports = withIs;
module.exports.proto = withIsProto;